const SECONDS_PER_MINUTE = 60;
const SECONDS_PER_HOUR = 3600;

enum Format {
  TEXT = 'TEXT',
  COLONS = 'COLONS',
  SHORT_TEXT = 'SHORT_TEXT',
}

export function formatSecondsToHoursMinutes(
  totalSeconds: number,
  format: keyof typeof Format,
): string {
  if (totalSeconds < 0) {
    switch (format) {
      case Format.COLONS:
        return '0:00';
      case Format.SHORT_TEXT:
        return '0 น.';
      case Format.TEXT:
      default:
        return '0 นาที';
    }
  }
  const totalHours = Math.floor(totalSeconds / SECONDS_PER_HOUR);
  const remainingSeconds = totalSeconds % SECONDS_PER_HOUR;
  const totalMinutes = Math.floor(remainingSeconds / SECONDS_PER_MINUTE);

  switch (format) {
    case Format.COLONS:
      return `${totalHours}:${totalMinutes.toString().padStart(2, '0')}`;
    case Format.SHORT_TEXT:
      if (totalHours === 0) return `${totalMinutes} น.`;
      if (totalMinutes === 0 && totalHours > 0) return `${totalHours} ชม.`;
      return `${totalHours} ชม. ${totalMinutes} น.`;
    case Format.TEXT:
    default:
      if (totalHours === 0) return `${totalMinutes} นาที`;
      if (totalMinutes === 0 && totalHours > 0) return `${totalHours} ชั่วโมง`;
      return `${totalHours} ชั่วโมง ${totalMinutes} นาที`;
  }
}
